import React, { useEffect, useRef, useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import '../styles/ProjectCard.css';

const ProjectCard = ({ year, title, description, tags, image }) => {
    const cardRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    // useEffect(() => {
    //     const observer = new IntersectionObserver(
    //         ([entry]) => setIsVisible(entry.isIntersecting),
    //         { threshold: 0.01 }
    //     );
    //     if (cardRef.current) observer.observe(cardRef.current);
    //
    //     return () => {
    //         if (cardRef.current) observer.unobserve(cardRef.current);
    //     };
    // }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(  //The IntersectionObserver API observes when a target element intersects with a defined root or viewport.
            ([entry]) => {
                // Below it Checks how much of the observed element is visible. If more than 60% of the element is visible (intersectionRatio > 0.6), it calls setIsVisible(true), indicating the element is visible.
                if (entry.intersectionRatio > 0.7) { //Adjust threshold here for slower overlap
                    setIsVisible(true);
                } else {
                    setIsVisible(false);
                }
            },
            //The threshold option defines the percentage of the element’s visibility that triggers the observer callback.
            // Here, it's set to 0.3 (30%). This means the callback is invoked when at least 60% of the element is visible, or when visibility drops below 60%.
            { threshold: [0.7] } // Trigger animation later
        );
        if (cardRef.current) observer.observe(cardRef.current);
        return () => {
            if (cardRef.current) observer.unobserve(cardRef.current);
        };
    }, []);

    return (
        <div ref={cardRef} className={`project-card ${isVisible ? 'in-view' : ''}`}>
            <div className="project-header">
                <h3>{year}</h3>
                <div className="project-tags">{tags}</div>
            </div>
            <h2 className="project-title">{title}</h2>
            <p className="project-description">{description}</p>
            <img src={image} alt={title} className="project-image"/>
            <div className="arrow-icon">
                <FaArrowRight/>
            </div>
        </div>
)
    ;
};

export default ProjectCard;